import React, { useContext } from "react";
import FileTreeView from "../../../Components/FileTreeView";
import RepoContext from "../../../context/Repos";
import SplitPane from "react-split-pane";
import CodeEditor from "./CodeEditor";
const DestinationPanel = () => {
  const { destFileTree, OutputRepoCreds } = useContext(RepoContext);

  return (
    <SplitPane
      split="vertical"
      minSize={200}
      maxSize={-200}
      defaultSize="30%"
      allowResize={true}
    >
      <FileTreeView
        fileTree={destFileTree ? destFileTree : {}}
        repoName={OutputRepoCreds ? OutputRepoCreds.repoName : "No repo"}
      />
      <CodeEditor type="output"/>
     
    </SplitPane>
  );
};

export default DestinationPanel;
